import { html } from 'uhtml';

const _wsuToggleMenuDefaults = {
  closeOnOutsideClick: true,
  closeOnEscape: true,
};

function ToggleMenu(menu, options) {
  /* eslint no-use-before-define: ["error", { "variables": false }] */
  options = { ..._wsuToggleMenuDefaults, ...options };

  function closeEventHandler(evt) {
    const isValid = {
      click:
        options.closeOnOutsideClick &&
        window.innerWidth >= 768 &&
        !(() => {
          for (let e = evt.target; e.parentNode; e = e.parentNode) {
            if (e.matches('[data-menutype=toggle],button[aria-pressed]')) {
              return true;
            }
          }
        })(),
      keydown:
        options.closeOnEscape &&
        (evt.key === 'Esc' || evt.key === 'Escape' || evt.which === 27),
    };

    if (menu.getAttribute('data-menustate') === 'closed') {
      evt.currentTarget.removeEventListener(evt.type, closeEventHandler);
    } else if (isValid[evt.type]) {
      newButton.click();
      evt.currentTarget.removeEventListener(evt.type, closeEventHandler);
    }
  }

  function buttonClick() {
    /* global jQuery */
    const newState =
      menu.getAttribute('data-menustate') === 'open' ? 'closed' : 'open';
    newButton.setAttribute('aria-pressed', newState === 'open');

    menu.classList.add('is-animating');
    const slideFunc = newState === 'open' ? 'slideDown' : 'slideUp';
    jQuery(menu)[slideFunc](175, () => {
      menu.setAttribute('data-menustate', newState);
      menu.classList.remove('is-animating');

      if (newState === 'open') {
        document.addEventListener('click', closeEventHandler);
        document.addEventListener('keydown', closeEventHandler);
        menu.focus();
      }
    });
  }

  menu.setAttribute('tabindex', -1);
  const menuButtonID = menu.getAttribute('aria-labelledby');
  const menuButton = document.getElementById(menuButtonID);
  const pressed = menu.getAttribute('data-menustate') === 'open';
  const newButton = html.node`
    <button
      id="${menuButtonID}"
      class="${`wsu-button button--toggle button--menu ${menuButton.className}`}"
      onClick=${() => buttonClick()}
      aria-pressed="${pressed}"
      aria-controls="${menu.id}">
        ${Array.from(menuButton.childNodes)}
    </button>
  `;
  menuButton.replaceWith(newButton);
}

export default ToggleMenu;
